import { render } from "./War.vue?vue&type=template&id=4eb4edee"
import script from "./War.vue?vue&type=script&lang=js"
export * from "./War.vue?vue&type=script&lang=js"

import "./War.vue?vue&type=style&index=0&id=4eb4edee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__